// Screen definition: Tickets
// Client-side pagination
import type { ScreenDefinition } from '@/types/screen-definition';

const TIPO_LABELS: Record<string, string> = {
  INCIDENTE: 'Incidente',
  REQUERIMIENTO: 'Requerimiento',
  DUDA: 'Duda',
};

export const ticketScreenDef: ScreenDefinition = {
  id: 'tickets',
  title: 'Tickets',
  itemLabel: 'tickets',

  columns: [
    {
      key: 'numero',
      header: 'Ticket',
      type: 'id',
      locked: true,
      config: {
        prefix: '#',
        subtitleField: 'titulo',
        linkPath: '/tickets/:id',
      },
    },
    {
      key: 'cliente',
      header: 'Cliente',
      type: 'avatar',
      sortable: false,
      config: {
        nameField: 'cliente.nombre',
      },
    },
    {
      key: 'tipo',
      header: 'Tipo',
      type: 'badge',
      config: { labelMap: TIPO_LABELS },
    },
    {
      key: 'estado',
      header: 'Estado',
      type: 'status',
    },
    {
      key: 'prioridad',
      header: 'Prioridad',
      type: 'priority',
    },
    {
      key: 'asignado_a',
      header: 'Asignado',
      type: 'avatar',
      sortable: false,
      config: {
        nameField: 'asignado_a.nombre',
        fallback: 'Sin asignar',
      },
    },
    {
      key: 'created_at',
      header: 'Fecha',
      type: 'custom', // Relative time + optional deadline — too specific for standard renderer
    },
    {
      key: '_counters',
      header: '',
      type: 'custom', // Comment count + attachment count icons
      sortable: false,
    },
  ],

  defaultSort: { field: 'created_at', order: 'desc' },

  pagination: {
    mode: 'client',
    defaultPageSize: 25,
  },

  search: {
    enabled: true,
    placeholder: 'Buscar por número o título...',
  },

  quickFilters: [
    {
      key: 'estado',
      options: [
        { value: 'NUEVO', label: 'Nuevo' },
        { value: 'EN_ANALISIS', label: 'En Análisis' },
        { value: 'EN_DESARROLLO', label: 'En Desarrollo' },
        { value: 'EN_PRUEBAS', label: 'En Pruebas' },
        { value: 'RESUELTO', label: 'Resuelto' },
        { value: 'CERRADO', label: 'Cerrado' },
      ],
    },
  ],

  filterSections: [
    {
      key: 'clasificacion',
      title: 'Clasificación',
      filters: [
        {
          key: 'tipo',
          label: 'Tipo',
          type: 'select',
          options: [
            { value: 'INCIDENTE', label: 'Incidente' },
            { value: 'REQUERIMIENTO', label: 'Requerimiento' },
            { value: 'DUDA', label: 'Duda' },
          ],
        },
        {
          key: 'prioridad',
          label: 'Prioridad',
          type: 'select',
          options: [
            { value: 'CRITICA', label: 'Crítica' },
            { value: 'ALTA', label: 'Alta' },
            { value: 'MEDIA', label: 'Media' },
            { value: 'BAJA', label: 'Baja' },
          ],
        },
      ],
    },
    {
      key: 'fechas',
      title: 'Fechas',
      filters: [
        { key: 'fecha', label: 'Rango de fecha', type: 'date-range' },
      ],
    },
  ],

  rowClick: { type: 'navigate', path: '/tickets/:id' },

  empty: {
    message: 'No se encontraron tickets',
    icon: 'Ticket',
  },
};
